export enum DetailsLinkTypeEnum {
  OUTDATED = 'OUTDATED',
  RELOCATION = 'RELOCATION',
  RELOCATION_ERROR = 'RELOCATION_ERROR',
  MOVEOUT = 'MOVEOUT',
  MOVEOUT_IGNORE_ERROR = 'MOVEOUT_IGNORE_ERROR',
}
